import * as RefreshTokenService from '../../services/refreshToken/RefreshTokenService';
import EventEmitter from '../../components/modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';
import ErrorsCodes from '../../const/ErrorsCodes';
import _ from 'lodash';
import LocalStorage from '../../const/LocalStorage';

export function execute() {
  verifyExpirationCustomer();
  RefreshTokenService.refreshToken()
    .then(response => {
      const adLoginCallcenterStorage = localStorage.getItem(LocalStorage.AD_LOGIN_CALLCENTER);
      const adLoginCallcenterName = adLoginCallcenterStorage ? JSON.parse(adLoginCallcenterStorage).name : null;
      const adLoginCallcenterRole = adLoginCallcenterStorage ? JSON.parse(adLoginCallcenterStorage).role : null;
      EventEmitter.emitEvent(Listener.REFRESH_TOKEN_CALLCENTER, response.adLogin, adLoginCallcenterName, adLoginCallcenterRole);      
    })
    .catch(error => {
      let errorType = ErrorsCodes.CALLCENTER_AUTHENTICATION_ERROR;
      if (_.get(error, 'response.status', 500) === 401) {
        errorType = ErrorsCodes.CALLCENTER_ACCESS_DENIED_ERROR;
      }
      localStorage.removeItem(LocalStorage.CUSTOMER_DATA_CALLCENTER);
      localStorage.removeItem(LocalStorage.AD_LOGIN_CALLCENTER);
      EventEmitter.emitEvent(Listener.SHOW_MODAL_INACTIVITY, errorType);
    });
}

function verifyExpirationCustomer() {
  const customerData = JSON.parse(localStorage.getItem(LocalStorage.CUSTOMER_DATA_CALLCENTER));
  if (customerData) {
    if (new Date() > new Date(customerData.expirationCustomer))
      localStorage.removeItem(LocalStorage.CUSTOMER_DATA_CALLCENTER);
  }
}



// WEBPACK FOOTER //
// ./src/usecases/refreshToken/RefreshTokenCallcenterUC.js